import {
  KSHEMA_HOSPI_DINDHAN_SURAKSHA,
  METHOD,
  SORT_ORDER,
} from "../../../../../components/consts";
import { axiosClient, axiosRequest } from "../../../../../components/service";
import {
  HEALTH_CLAIM_PROCESSING_SEARCH,
  HEALTH_CLAIM_STATUS_LIST,
  HEALTH_MASTER_SERVICE,
  REACT_APP_KSHEMA_POC2,
  REACT_APP_VAM_CONTEXT_INGESTION,
  REACT_APP_VAM_ENDPOINT,
  HEALTH_CLAIM_INGESTION
} from "../../../../../components/urls";
import { sortList, titleCase } from "../../../../../components/utilFunctions";

export const getClaimStatus = (setClaimStatus) => {
  axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_CLAIM_INGESTION}/claim-status/2`)
    .then((data) => {
        setClaimStatus(
          data?.data?.map((item) => {
            return {
              label: titleCase(item),
              value: item,
            };
          })
        );
      
    })
    .catch((error) => {
      console.error(error);
    });
};
export const getClaimSubStatus = ( setClaimSubStatus) => {
  axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_CLAIM_INGESTION}/claim-sub-status/2`)
    .then((data) => {
        setClaimSubStatus(
          data?.data?.map((item) => {
            return {
              label: item,
              value: item,
            };
          })
        );
      
    })
    .catch((error) => {
      console.error(error);
    });
};
export const getPolicyStatusOptions = (setPolicyStatusOptions) => {
  axiosRequest()
    .get(`${REACT_APP_KSHEMA_POC2}/government-status`)
    .then((data) => {
      const policyData = data.data.status.flat("Infinity").map((list) => {
        return {
          label: titleCase(list),
          value: titleCase(list),
        };
      });
      setPolicyStatusOptions(policyData);
    })
    .catch((error) => {
      console.error(error);
    });
};
export const getAssignTo = (setAssignedTos) => {
  axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}`)({
    url: "getClaimAssigned",
    method: METHOD.GET,
  })
    .then((data) => {
      const assigned = data.data;
      // Sort products by productName (label) alphabetically
      assigned && assigned.sort((a, b) => a - b);
      // Map products to label-value pairs
      const sortedAssigned = assigned
        .filter(
          (product) =>
            product !== null && product !== undefined && product !== ""
        ) // Filter out null and undefined values
        .map((product) => {
          return {
            label: product,
            value: product,
          };
        });

      setAssignedTos(sortedAssigned);
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getRoles = (setClaimRoles) => {
  axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_CLAIM_INGESTION}/roles/2`)
    .then((data) => {
      const filteredData = data.data.filter(
        (list) => list !== null && list !== ""
      );
      setClaimRoles(
        filteredData.map((list) => {
          return {
            label: list,
            value: list,
          };
        })
      );
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getStatesList = (setStatesList) => {
  axiosRequest()
    .get(`${REACT_APP_KSHEMA_POC2}/states/${KSHEMA_HOSPI_DINDHAN_SURAKSHA}`)
    .then((response) => {
      const sortedStates = sortList(
        "state_name",
        SORT_ORDER.ASC,
        response?.data
      );
      const mappedStates = sortedStates.map((state) => ({
        label: state?.state_name,
        value: state?.state_id,
      }));
      setStatesList(mappedStates);
    })
    .catch((error) => {
      console.error("Error fetching states:", error);
    });
};

export const getIsShowButton=(subStatus)=>{
  const isShow = subStatus !== "Claim Approval In-Progress"
          && subStatus !== "Claim Payout In-Progress"  && subStatus !== "Account Details Missing" && subStatus !== "A/C Holder Details mismatch"
          && subStatus !== "Balance Check Success" && subStatus !== "Balance Check Failed"
          && subStatus !== "Penny Drop Success" && subStatus !== "Penny Drop Failed"
          && subStatus !== "Penny Drop Pending" && subStatus !== "Penny Drop Returned"
          && subStatus !== "Penny Drop Rejected" && subStatus !== "Penny Drop Processed"
          && subStatus !== "Payment Disbursement Success" && subStatus !== "Payment Disbursement Failed"
          && subStatus !== "Payment Disbursement Pending" && subStatus !== "Payment Disbursement Returned"
          && subStatus !== "Payment Disbursement Rejected" && subStatus !== "Payment Disbursement Processed"
          return isShow
}

export const getDistrictList = (state, setDistrictList) => {
  axiosRequest()
    .get(
      `${REACT_APP_KSHEMA_POC2}/districts/${KSHEMA_HOSPI_DINDHAN_SURAKSHA}/${state}`
    )
    .then((response) => {
      const districtList = sortList(
        "district_name",
        SORT_ORDER.ASC,
        response?.data
      );
      setDistrictList(
        districtList?.map((item) => {
          return {
            label: item.district_name,
            value: item.district_id,
          };
        })
      );
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getMandalList = (state, district, setMandalList) => {
  axiosRequest()
    .get(
      `${REACT_APP_KSHEMA_POC2}/mandals/${KSHEMA_HOSPI_DINDHAN_SURAKSHA}/${state}/${district}`
    )
    .then((response) => {
       const mandalList = sortList(
        "mandal_name",
        SORT_ORDER.ASC,
        response?.data
      );
      setMandalList(
        mandalList?.map((item) => {
          return {
            label: item.mandal_name,
            value: item.mandal_id,
          };
        })
      );
    })
    .catch((error) => {
      console.error(error);
    });
};
export const getVillageList = (state, district, mandal, setVillageList) => {
  axiosRequest()
    .get(
      `${REACT_APP_KSHEMA_POC2}/villages/${KSHEMA_HOSPI_DINDHAN_SURAKSHA}/${state}/${district}/${mandal}`
    )
    .then((response) => {
       const villageList = sortList(
        "village_name",
        SORT_ORDER.ASC,
        response?.data
      );
      setVillageList(
        villageList?.map((item) => {
          return {
            label: item.village_name,
            value: item.village_id,
          };
        })
      );
    })
    .catch((error) => {
      console.error(error);
    });
};

export const searchClaimProcessing = (
  filters,
  queryParam,
  setClaimProcessingList,
  setTotalPages, // optional
  setTotalRecords // optional
) => {
  axiosRequest()
    .post(
      `${REACT_APP_VAM_ENDPOINT}/${HEALTH_CLAIM_PROCESSING_SEARCH}`,
      filters,
      { params: queryParam }
    )
    .then((data) => {
      setClaimProcessingList(data?.data?.data?.claims || []);
      if (setTotalPages) {
        setTotalPages(data?.data?.data?.totalPages)
      }
      if(setTotalRecords) {
        setTotalRecords(data?.data?.data?.totalRecords)
      }
    })
    .catch((error) => {
      setClaimProcessingList([]);
      console.error(error);
    });
};

export const getHospitalClaimDetails = async(claimId, setHealthClaimDetails) => {  
  axiosRequest()
    .get(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_CLAIM_INGESTION}/claim/${claimId}`, )
    .then((data) => {
      setHealthClaimDetails(data?.data);
    })
    .catch((error) => {
      console.error(error);
    });
};